import { motion } from "framer-motion";

export const XPostsPanel = ({ posts = [] }) => (
  <motion.div
    initial={{ opacity: 0, y: 8 }}
    animate={{ opacity: 1, y: 0 }}
    className="panel lg:col-span-6 flex flex-col min-h-[200px] max-h-[420px]"
    data-testid="x-posts-panel"
  >
    <div className="panel-header shrink-0">
      <h3 className="font-display text-sm font-bold uppercase tracking-tight">Social · X Posts</h3>
      <span className="label-micro">{posts.length} rows</span>
    </div>
    <div className="panel-scroll-body divide-y divide-border">
      {posts.length === 0 ? (
        <p className="p-4 text-sm text-text-secondary font-mono">No x_posts in database.</p>
      ) : (
        posts.map((p) => (
          <div key={p.id} className="p-3 hover:bg-surface-muted">
            <div className="flex justify-between text-[10px] uppercase text-text-secondary">
              <span>@{p.user}</span>
              <span>{p.source}</span>
            </div>
            <p className="text-[11px] font-mono mt-1 leading-relaxed line-clamp-3">{p.text}</p>
            <div className="text-[10px] text-text-secondary mt-1 num">
              RT {p.retweets} · ♥ {p.likes}
            </div>
          </div>
        ))
      )}
    </div>
  </motion.div>
);

export default XPostsPanel;
